export default __webpack_public_path__ + "static/media/isotype_primary.4c457f1a.svg";